// extracted by mini-css-extract-plugin
module.exports = {"story-container":"StoryContainer_story-container__2IQV6","title":"StoryContainer_title__3KrEe"};